<div id="batchDelete" class="category-table custom-datatable">
    <ng-container *ngIf="tableItem$ | async as searchRes">
    <div class="table-responsive">
        <!-- <form>
            <div class="mb-3 row">
                <label for="table-complete-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label>
                <div class="col-xs-3 col-sm-auto">
                  <input id="table-complete-search" type="text" class="form-control" name="searchTerm"  [(ngModel)]="searchText" autocomplete="off">
                </div>
            </div>
          </form> -->
        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col" sortable="product_name" (sort)="onSort($event)">Name</th>
                <th scope="col" sortable="price" (sort)="onSort($event)" >Description</th>
                <th scope="col" sortable="status" (sort)="onSort($event)">Price</th>
                <th scope="col" sortable="population" (sort)="onSort($event)">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor = 'let menuItem of searchRes.data | filter:searchText'>
            <td>
                <img [src]="getImage(menuItem.menuItemImage)" class="imgTable" style="width: 20px">
            </td>
            <td>{{ menuItem.name }}</td>
            <td>{{ menuItem.description }}</td>
            <td>{{ menuItem.basePrice}}</td>
            <td>
                <a href="javascript:void(0)" (click)="editMenuItem(menuItem.id)"><i class='fa fa-edit f-12'></i></a>&nbsp;
                <a href="javascript:void(0)" (click)="deleteMenuItem(menuItem.id)"><i class="fa fa-trash-o"></i></a>
            </td>
            </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-center p-2">
            <mat-paginator #paginator
               class="demo-paginator"
               (page)="handlePageEvent($event)"
               [length]="searchRes.totalCount"
               [pageSize]="searchRes.pageSize"
               [disabled]="false"
               [showFirstLastButtons]="true"
               [pageSizeOptions]="false"
               [hidePageSize]="false"
               [pageIndex]="searchRes.currentPage - 1"
               aria-label="Select page">
            </mat-paginator>
         </div> 
    </div>
    
</ng-container>
</div>
<app-menu-item-modal #menuItemModal [addOrEdit]="'Edit'" [menuItemId]="selectedId"></app-menu-item-modal>